export default {"src":"/_next/static/media/wa-outline.a42d5214.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};